module.exports = __webpack_public_path__ + "img/Rain_1.2x1.2_U1.2_15.wDGU_f.Al_c.Br.c02ac28c.png";